import { createApiHandler } from './handler';

const addresses = {
  apiClient: null,
  path: '/addresses',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

};

export default addresses;
